import {useLoginContext, useUserContext} from '@hconnect/login'
import {Avatar, MenuItemConfig} from '@hm/fundamental'
import {mdiAccountCircleOutline} from '@mdi/js'
import {useMemo} from 'react'
import {useTranslation} from 'react-i18next'

import HProduceLogo from '../../../assets/logo.svg'

import {useGetLanguageMenuItem} from './useLanguageMenuItem'
import {useRoleMenuItem} from './useRoleMenuItem'
import {useThemeMenuItem} from './useThemeMenuItem'

interface UseUserMenuItemsParams {
  onSelectPersona: Parameters<typeof useRoleMenuItem>[0]['onSelectPersona']
}

export const useUserMenuItems = ({onSelectPersona}: UseUserMenuItemsParams) => {
  const {t} = useTranslation()

  const languageMenuItem = useGetLanguageMenuItem()
  const themeMenuItem = useThemeMenuItem()
  const roleMenuItem = useRoleMenuItem({onSelectPersona})

  const {logout} = useLoginContext()
  const {loggedUser} = useUserContext()

  return useMemo(
    (): MenuItemConfig[] => [
      ...(loggedUser
        ? [
            {
              key: 'user',
              title: loggedUser.name ?? '',
              customIcon: <Avatar name={loggedUser.name ?? ''} />,
              subtitle: loggedUser.eMail ?? '',
              items: [
                {
                  key: loggedUser.id,
                  title: loggedUser.name ?? '',
                  icon: mdiAccountCircleOutline,
                  view: <img src={HProduceLogo} alt={t('suite.header.titleLogoAlt')} />
                }
              ]
            }
          ]
        : []),
      ...(roleMenuItem ? [roleMenuItem] : []),
      languageMenuItem,
      themeMenuItem,
      ...(loggedUser
        ? [
            {
              key: 'logout',
              title: t('suite.header.logout'),
              onClicked: logout
            }
          ]
        : [])
    ],
    [logout, languageMenuItem, themeMenuItem, loggedUser, roleMenuItem, t]
  )
}
